import { render, staticRenderFns } from "./ImgCard.vue?vue&type=template&id=b8b51e4c&scoped=true&"
import script from "./ImgCard.vue?vue&type=script&lang=ts&"
export * from "./ImgCard.vue?vue&type=script&lang=ts&"
import style0 from "./ImgCard.vue?vue&type=style&index=0&id=b8b51e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b51e4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
